import { Grid } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { ITaskTypeCol } from "ui/Scripts/source/models/task/taskTypeCol";
import { Translations } from "ui/Scripts/source/models/translations";
import { ITaskTypeFieldPropUpdate } from "../../FormDesignerTypes";
import { FormField } from "ui/Scripts/source/components/framework/FormField";
import { AppCkEditor } from "source/components/framework/AppCkEditor";

interface IFormDesignerComponentPropertiesRichTextProps {
    formFieldMargin: string;
    taskTypeCol?: ITaskTypeCol;
    onTaskTypePropUpdate?: (values: ITaskTypeFieldPropUpdate[]) => void;
}

export const FormDesignerComponentPropertiesRichText = (
    props: IFormDesignerComponentPropertiesRichTextProps
) => {
    const [ckEditorDataId, setCkEditorDataId] = useState(0);
    const ckEditor = useRef<any>(null);
    const ckEditorInstanceIsReady = useRef(false);
    const ckEditorSettingData = useRef(false);

    const destroyCkEditor = () => {
        if (!ckEditor.current) return;
        ckEditor.current.destroy();
        ckEditor.current = null;
    };

    const handleCkEditorChange = (ev) => {
        if (!ckEditorInstanceIsReady.current || ckEditorSettingData.current) return;
        const value: string = ev.editor.getData();
        props.onTaskTypePropUpdate([{
            field: props.taskTypeCol?.field,
            name: "title",
            value
        }]);
    };

    const setCkEditorContent = (value: string) => {
        if (!ckEditor.current) return;
        ckEditorSettingData.current = true;
        setCkEditorDataId(ckEditorDataId + 1);
        ckEditor.current.on("change", handleCkEditorChange);
        ckEditor.current.setData(value, {
            callback: () => {
                ckEditor.current.resetDirty();
                ckEditorSettingData.current = false;
            }
        });
        setCkEditorDataId(ckEditorDataId + 1);
    };

    const handleCkEditorInstanceReady = (ev) => {
        ckEditor.current = ev.editor;
        ev.editor.resetDirty();
        setCkEditorContent(props.taskTypeCol?.title ?? "");
        ckEditorInstanceIsReady.current = true;
    };

    useEffect(() => {
        return () => {
            destroyCkEditor();
        };
    }, []);

    useEffect(() => {
        setCkEditorContent(props.taskTypeCol?.title ?? "");
    }, [props.taskTypeCol?.field ?? ""]);

    return (
        <Grid item sm={12}>
            <FormField title={Translations.Text} margin={props.formFieldMargin} required={true}>
                <AppCkEditor
                    value={props.taskTypeCol?.title ?? ""}
                    dataId={ckEditorDataId}
                    height="min(calc(100vh - 450px), 300px)"
                    toolbar={[
                        ["Cut", "Copy", "Paste", "PasteText", "PasteFromWord", "-", "Undo", "Redo"],
                        ["Link", "Unlink"],
                        ["Table"],
                        ["TextColor", "BGColor", "Maximize"],
                        ["base64image"],
                        "/",
                        ["Format", "Font", "FontSize"],
                        ["Bold", "Italic", "Underline", "Strike", "Subscript", "Superscript", "RemoveFormat"],
                        ["JustifyLeft", "JustifyCenter", "JustifyRight", "JustifyBlock"],
                        ["NumberedList", "BulletedList", "Outdent", "Indent"]
                    ]}
                    onInstanceReady={handleCkEditorInstanceReady}
                    onChange={handleCkEditorChange}
                />
            </FormField>
        </Grid>
    );
};
